import { bootstrapApplication } from '@angular/platform-browser'

import { AppComponent } from './app/app.component'
import { appConfig } from './app/app.config'
import * as Sentry from '@sentry/angular'
import { environment } from './environments/environment'
import packageJson from '../package.json'
import { DebugLogger } from './app/utils/debug-logger'

// Start debug log capture in development
if (!environment.production) {
  DebugLogger.startCapture()
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err))

const EXPECTED_ERROR_PATTERNS = [
  'auth/expired-action-code',
  'auth/invalid-action-code',
  // Firebase Auth SDK がポップアップ決着後に内部コールバック（origin 検証・storage 確認）から遅れて reject を呼んで投げる内部 assertion。
  // plain Error で投げられアプリ側で処理できず、ログイン処理自体は既に完了しているため実害もない
  'INTERNAL ASSERTION FAILED: Pending promise was never set',
]

// 音声/動画ファイルの Storage 404 はアセスメント詳細画面の音声ダウンロードで頻発するノイズ。
// 他の Storage エラーは検知したいため、拡張子で音声/動画に限定している。
const AUDIO_EXTENSIONS_RE = /\.(mp[34]|m4a|wav|webm)\b/i

Sentry.init({
  dsn: environment.sentryDsn,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.browserProfilingIntegration(),
    Sentry.replayIntegration(),
    Sentry.breadcrumbsIntegration({
      dom: false,
    }),
  ],
  environment: 'production',
  release: `${packageJson.name}@${packageJson.version}`,
  tracesSampleRate: 0.1,
  tracePropagationTargets: ['localhost', environment.graphqlUrl],
  beforeSend(event) {
    const messages = event.exception?.values?.map((v) => v.value ?? '') ?? []
    if (event.message) {
      messages.push(event.message)
    }
    const isExpected = messages.some(
      (msg) =>
        EXPECTED_ERROR_PATTERNS.some((pattern) => msg.includes(pattern)) ||
        (msg.includes('storage/object-not-found') &&
          AUDIO_EXTENSIONS_RE.test(msg)),
    )
    if (isExpected) {
      return null
    }
    return event
  },
})
